import { filter, orderBy, isEqual, get, first, find } from 'lodash';
import PlansActionType from '../../common/PlansActionType';

const initialState = {
  contractPlans: [],
  nonContractPlans: [],
  ufbAvailable: false,
  connectionPrice: 0,
  modemPrice: 0,
  shippingPrice: 0,
  isContractSelected: false,
  isByoModemSelected: false,
  isImportantInfoTickbox: false,
  hasSwitchedToOpenTerm: false,
  selectedPlanIndex: 0,
  fetched: false,
  byoModemDiscountPrice: 0,
};

const isContractEqual = isContract => plan => isEqual(plan.isContract, isContract);

// filter plans by contract type and order by price
const filterPlans = (plans, isContract) => {
  const filteredPlans = filter(plans, isContractEqual(isContract));
  return orderBy(filteredPlans, 'price');
};

const PlansReducer = (state = initialState, action) => {
  switch (action.type) {
    case PlansActionType.SET_MOBILE_DISCOUNT:
      return {
        ...state,
        ...action.withMobileDiscountInfo
      };
    case PlansActionType.STORE_PLAN_DATA:
      return {
        ...state,
        selectedPlanIndex: 0,
        fetched: true,
        isContractSelected: state.isContractSelected,
        isByoModemSelected: state.isByoModemSelected,
        isImportantInfoTickbox: state.isImportantInfoTickbox,
        ufbAvailable: action.ufbAvailable,
        ufbReady: action.ufbReady,
        connectionPrice: action.connectionPrice,
        modemPrice: action.modemPrice,
        byoModemDiscountPrice: action.byoModemDiscountPrice,
        shippingPrice: action.shippingPrice,
        isCurrentPlanAvailable: action.isCurrentPlanAvailable,
        provider: action.provider,
        contractPlans: filterPlans(action.plans, true),
        nonContractPlans: filterPlans(action.plans, false)
      };
    case PlansActionType.SET_CONTRACT_SELECTED:
      return { ...state, isContractSelected: action.isContractSelected };
    case PlansActionType.SET_BYOMODEM_SELECTED:
      return { ...state, isByoModemSelected: action.isByoModemSelected };
    case PlansActionType.SET_IMPORTANTINFO_TICKBOX_SELECTED:
      return { ...state, isImportantInfoTickbox: action.isImportantInfoTickbox };
    case PlansActionType.SWITCH_TO_OPEN_TERM:
      return { ...state, isContractSelected: false, hasSwitchedToOpenTerm: true };
    case PlansActionType.SET_SELECTED_PLAN:
      return { ...state, selectedPlanIndex: action.id, selectedPlanId: action.id };
    case PlansActionType.RESET_ALL:
      return {
        ...initialState,
        ufbAvailable: state.ufbAvailable,
        ufbReady: state.ufbReady,
        withMobileDiscount: state.withMobileDiscount
      };
    default:
      return state;
  }
};

const getSelectedPlan = (state) => {
  const selectedPlanId = state.plans.selectedPlanId;
  const selectedPlan = find(
    [...state.plans.contractPlans, ...state.plans.nonContractPlans],
    plan => plan.planId === selectedPlanId && !plan.stopSell
  );
  if (selectedPlan.contract === state.plans.isContractSelected) {
    return selectedPlan;
  }
  return find(
    state.plans.isContractSelected
      ? state.plans.contractPlans
      : state.plans.nonContractPlans,
    plan => plan.label === selectedPlan.label
  );
};

const getAvailablePlans = (state) => {
  const plans = state.plans.isContractSelected
    ? state.plans.contractPlans
    : state.plans.nonContractPlans;
  return filter(plans, plan => !plan.stopSell);
};

const getTerm = (state) => {
  if (state.plans.contractPlans.length !== 0 && state.plans.contractPlans[0].term) {
    const term = state.plans.contractPlans[0].term;
    return term.toLowerCase();
  }
  return null;
};

const getContractTerm = (state, isContact) => isContact
  ? getTerm(state)
  : 'No term';

const getHasSwitchedToOpenTerm = state => !state.plans.isContractSelected && state.plans.hasSwitchedToOpenTerm;

const checkWithMobileDiscount = state => state.plans.withMobileDiscount;
const getMobileDiscountInfo = state => ({
  withMobileDiscount: state.plans.withMobileDiscount,
  linkedMobile: state.plans.linkedMobile
});

export const PlansSelector = {
  getSelectedPlan,
  getAvailablePlans,
  getContractTerm,
  getHasSwitchedToOpenTerm,
  getMobileDiscountInfo,
  getContractType: state => getContractTerm(state, state.plans.isContractSelected),
  getBasePrice: state => get(first(getAvailablePlans(state)), 'price'),
  getUfbAvailable: state => state.plans.ufbAvailable,
  getUfbReady: state => state.plans.ufbReady,
  getTechnologyType: state => get(first(getAvailablePlans(state)), 'type'),
  getConnectionPrice: state => state.plans.connectionPrice,
  getShippingPrice: state => state.plans.shippingPrice,
  getModemPrice: state => state.plans.modemPrice,
  getByoModemDiscountPrice: state => state.plans.byoModemDiscountPrice,
  getIsFetched: state => state.plans.fetched,
  getSelectedPlanId: state => state.plans.selectedPlanId,
  getIsContractSelected: state => state.plans.isContractSelected,
  getIsByoModemSelected: state => state.plans.isByoModemSelected,
  getIsImportantInfoTickboxSelected: state => state.plans.isImportantInfoTickbox,
  getCurrentPlanAvailable: state => state.plans.isCurrentPlanAvailable,
  getProvider: state => state.plans.provider,
  isSelectedPlanFibre: state => getSelectedPlan(state).type === 'Fibre',
  checkWithMobileDiscount,
};

export default PlansReducer;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/PlansReducer.js
 **/